import { COPILOT_CONSTANTS } from '../constants';

export function validateQueryLength(query: string): void {
  if (query.length > COPILOT_CONSTANTS.INPUT_LIMITS.MAX_CHARACTER_COUNT) {
    throw new RangeError('Your request exceeds the 5,000-character limit, including form formatting and attachments. Shorten it and try again. Your draft has been retained.');
  }
}

export function validateAskResponse(response: any): void {
  const data = response?.data || response;
  if (data?.title === 'Input Too Long') {
    const limit = /maximum allowed length of (\d+) characters/.exec(data.detail || '')?.[1];
    throw new RangeError(`Your request exceeds ${limit ? `the ${limit}-character` : 'the input'} limit for this tile. Shorten it and try again. Your draft has been retained.`);
  }
  if (!response || response instanceof Error || Number(response.status ?? data?.status) >= 400) {
    throw new Error('The request could not be submitted. Your draft has been retained. Please try again.');
  }
}

// Generated by Copilot
// updated on: 2026-10-26 | 7 lines added | [Auto Generated] | Enforce the complete untrimmed ask transport ceiling | Time Taken 1 min
// Generated by Copilot
// updated on: 2026-10-26 | 11 lines added | [Auto Generated] | Recognize tightened tile limits and resolved HTTP failures without exposing server detail | Time Taken 2 min
